/**
 * LiveKit data-channel payload for trainer → student focus / PiP / media policy.
 */

export const LIVE_SESSION_POLICY_TYPE = "codelive.session-policy" as const;

export type LiveSessionPolicyMessage = {
  type: typeof LIVE_SESSION_POLICY_TYPE;
  v: 1;
  distraction_detection_enabled: boolean;
  student_pip_allowed: boolean;
  students_can_unmute: boolean;
  students_can_enable_camera: boolean;
  at: number;
};

export function encodeLiveSessionPolicy(
  msg: Omit<LiveSessionPolicyMessage, "type" | "v">,
): Uint8Array {
  const payload: LiveSessionPolicyMessage = {
    type: LIVE_SESSION_POLICY_TYPE,
    v: 1,
    ...msg,
  };
  return new TextEncoder().encode(JSON.stringify(payload));
}

export function decodeLiveSessionPolicy(
  data: Uint8Array,
): LiveSessionPolicyMessage | null {
  try {
    const raw = JSON.parse(new TextDecoder().decode(data)) as Partial<
      LiveSessionPolicyMessage
    >;
    if (raw?.type !== LIVE_SESSION_POLICY_TYPE || raw.v !== 1) return null;
    return {
      type: LIVE_SESSION_POLICY_TYPE,
      v: 1,
      distraction_detection_enabled: Boolean(
        raw.distraction_detection_enabled,
      ),
      student_pip_allowed: Boolean(raw.student_pip_allowed),
      // Default true when older trainers omit these fields.
      students_can_unmute:
        raw.students_can_unmute === undefined
          ? true
          : Boolean(raw.students_can_unmute),
      students_can_enable_camera:
        raw.students_can_enable_camera === undefined
          ? true
          : Boolean(raw.students_can_enable_camera),
      at: Number(raw.at) || Date.now(),
    };
  } catch {
    return null;
  }
}
